const removeFieldFromCollectionRounds = (
  rounds = [],
  usageEntries = [],
  fieldId,
  { roundIdKey, fieldIdKey }
) => {
  if (!Array.isArray(rounds) || !usageEntries.length || !fieldId) {
    return rounds;
  }

  const targetRoundIds = new Set(
    usageEntries.map((usageEntry) => usageEntry?.roundid).filter(Boolean)
  );

  return rounds.map((round) => {
    if (!targetRoundIds.has(round?.[roundIdKey])) {
      return round;
    }

    const nextFields = (round?.fields ?? []).filter(
      (field) => field?.[fieldIdKey] !== fieldId
    );

    return {
      ...round,
      fields: nextFields,
      fieldcount: nextFields.length
    };
  });
};

export default removeFieldFromCollectionRounds;
